import React, { useState, memo, useEffect } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DraggableListItem from "./DraggableListItem";
import "./DraggableList.scss";
import { Button, Tooltip } from "antd";
import { sortBy } from "lodash";

const DraggableList = (props) => {
  console.log("eaqmsd DraggableList props", props);

  const {
    items,
    handleDragItemAndDrop,
    addItem,
    addChildrenItem,
    deleteItem,
    handleAddNewItem,
    updateItemDetail,
    showDetailAddons,
    loading,
    isEditable
  } = props;
  const [isCollapseAll, setIsCollapseAll] = useState(true);

  let relatedList = items.filter(
    (item) => item.parent_type_c === "content_area"
  );
  let sortedRelatedList = sortBy(relatedList, "position");

  console.log("DraggableList finalJson", {
    sortedRelatedList,
    items,
  });

  return (
    <DndProvider backend={HTML5Backend}>
      {relatedList.length == 0 && isEditable && (
        <Button onClick={() => handleAddNewItem()}>+ Add</Button>
      )}
      {relatedList.length > 0 && isEditable && (
        <Button onClick={() => setIsCollapseAll(!isCollapseAll)}>
          {(isCollapseAll ? "Uncollapse" : "Collapse") + " all"}
        </Button>
      )}
        <div
          className={`draggable-list-crud-container ${!isEditable ? "preview" : ""}`}
        >
          {sortedRelatedList.map((item, index) => (
            <DraggableListItem
              key={`${item.type_c}-${item.id}`}
              item={item}
              itemIndex={index}
              itemSiblings={sortedRelatedList}
              items={items}
              isCollapseAll={isCollapseAll}
              handleDragItemAndDrop={handleDragItemAndDrop}
              addChildrenItem={addChildrenItem}
              addItem={addItem}
              deleteItem={deleteItem}
              level={1}
              updateItemDetail={updateItemDetail}
              showDetailAddons={showDetailAddons}
              loading={loading}
              isEditable={isEditable}
            />
          ))}
        </div>
    </DndProvider>
  );
};

export default memo(DraggableList);
